export enum DynamicProductWidgetSubtypes {
    Image = "Image",
    Price = "Price",
    Title = "Title",
    Description = "Description"
}

export {
    DynamicProductWidgetSubtypes  as default,
}



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetSubtypes.ts